import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExtraInfo } from "./ExpertMessageExtraInfoHook";
// Set the default state values for each context
export const ExpertMessageExtraInfoContext = /*#__PURE__*/createContext({});
export const ExpertMessageExtraInfoContextProvider = ({
  children
}) => {
  const extraInfo = useExtraInfo();
  return /*#__PURE__*/React.createElement(ExpertMessageExtraInfoContext.Provider, {
    value: extraInfo
  }, children);
};
export const useExpertMessageExtraInfoContext = () => {
  return useContext(ExpertMessageExtraInfoContext);
};
ExpertMessageExtraInfoContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};